/* The product-page "Also guaranteed to fit your vehicle" row (assets/cdx-product-fits.js) is now
   loaded directly by snippets/cdx-vehicle-fit.liquid, so it downloads alongside the page. */

const mainBody = document.querySelector('body');

function getCSSVar(name) {
  return parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)) || 0;
}

/* Phones: the vehicle bar sticks under the header the moment the header reaches it.
   9/23/26: the browser does the sticking itself (CSS position: sticky on the bar's section,
   styles in the phone-bar block at the end of this file). Before, this script switched the
   bar to position: fixed on scroll, which on real phones lands a frame late during
   flick-scrolling and made the bar shudder. This script now only notes WHEN the bar is stuck
   ("cdx-stuck" class, used e.g. to offset jump links); it never moves anything.
   Desktop never pins (the header's "Shopping for" button handles changes there). */
function checkScrollThreshold() {
  const target = document.querySelector('.easysearch-block-container');
  if (!target) return;
  const sec = target.closest('.shopify-section') || target.parentElement;
  mainBody.classList.remove('with-ymm');
  target.classList.remove('scrolled');

  if (window.innerWidth >= 750) {
    sec.classList.remove('cdx-ymm-sticky');
    target.classList.remove('cdx-stuck');
    return;
  }
  sec.classList.add('cdx-ymm-sticky');
  const headerHeight = getCSSVar('--header-height');
  target.classList.toggle('cdx-stuck', sec.getBoundingClientRect().top <= headerHeight - 0.5);
}

window.addEventListener('scroll', checkScrollThreshold, { passive: true });
window.addEventListener('resize', checkScrollThreshold);
checkScrollThreshold();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkScrollThreshold);

/* REMOVE 'SELECT' FROM DROP DOWNS */
document.querySelectorAll('.easysearch-block-container select option').forEach((option) => {
  const text = option.textContent.trim();
  if (text.toLowerCase().startsWith('select ')) {
    option.textContent = text.replace(/^select\s+/i, '');
  }
});

/* CREATE RESET BUTTON */
function injectResetButton() {
  const actionsHolder = document.querySelector('.easysearch-holder');
  const yearSelect = document.querySelector('#easysearch_field_2899');
  const mainWidget = document.querySelector('.easysearch-main-widget'); // add this

  console.log(actionsHolder, 'ACTION HOLDER');
  if (!actionsHolder || !yearSelect) return;    

  // Avoid injecting multiple times
  if (actionsHolder.querySelector('.easysearch-btn-reset')) return;

  const resetBtn = document.createElement('button');
  // Text + old arrow glyph (used on phones) + modern icon (used on desktop via custom.css)
  resetBtn.innerHTML = '<span class="es-reset-label">Reset</span> <span class="es-reset-glyph">↺</span>' +
    '<svg class="es-reset-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 12a9 9 0 1 0 2.64-6.36"/><path d="M3 4v5h5"/></svg>';
  resetBtn.setAttribute('aria-label', 'Reset vehicle search');
  resetBtn.className = 'easysearch-btn easysearch-btn-reset';
  resetBtn.type = 'button';
  resetBtn.style.marginLeft = '1rem';

  resetBtn.addEventListener('click', () => {
    // reset the select
    yearSelect.selectedIndex = 0;
    yearSelect.dispatchEvent(new Event('change', { bubbles: true }));

    // also remove searched class from main widget
    if (mainWidget) {
      mainWidget.classList.remove('searched');
    }
  });

  actionsHolder.appendChild(resetBtn);
}


injectResetButton();



const bulbSelect = document.querySelector('.easysearch-select-holder-last select');
const mainWidget = document.querySelector('.easysearch-main-widget');

if (bulbSelect && mainWidget) {
  function updateClass() {
    if (bulbSelect.value && bulbSelect.value.trim() !== "") {
      mainWidget.classList.add('searched');
    } else {
      mainWidget.classList.remove('searched');
    }
  }

  // Run once on load
  updateClass();

  // Update on change
  bulbSelect.addEventListener('change', updateClass);
}


/* =====================================================================
   9/23/26 — DESKTOP HEADER EXTRAS (hidden on phones by custom.css)
   - Vehicle chip ("Shopping for <vehicle>") showing the vehicle picked in the vehicle search
   - "Bulb Location: <current> v" dropdown (bulb locations for that vehicle)
   - Ship-today countdown (2 PM Eastern, Mon–Fri)
   - "Plug & Play — installs in minutes"
   ===================================================================== */
(function () {
  if (window.__cdxHeaderExtras) return;
  window.__cdxHeaderExtras = true;

  var ICON_TRUCK = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17H3v-5l2-5h9l3 5h3a1 1 0 0 1 1 1v4h-2"/><path d="M9 17h6"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M5 12h12"/></svg>';
  var ICON_CHEVRON = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var ICON_EDIT = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  var ICON_CLOCK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  var ICON_SHIP = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 5h13v11H1z"/><path d="M14 9h4l4 4v3h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';
  var ICON_PLUG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 2v6M15 2v6"/><path d="M6 8h12v4a6 6 0 0 1-12 0z"/><path d="M12 18v4"/></svg>';

  function selects() {
    return Array.prototype.slice.call(document.querySelectorAll('.easysearch-block-container .easysearch-holder select'));
  }

  function titleCase(s) {
    return String(s).split(/(\s+|-|\/)/).map(function (w) {
      if (!/[A-Za-z]/.test(w)) return w;
      if (/^(GMC|RAM|BMW|VW|SRT|HD|SUV|II|III)$/i.test(w) || w.length <= 2) return w.toUpperCase();
      if (/[a-z]/.test(w)) return w; // already mixed case (e.g. "F-350 Super Duty")
      return w.charAt(0) + w.slice(1).toLowerCase();
    }).join('');
  }

  function vehicleText() {
    var s = selects();
    if (s.length < 3) return '';
    var parts = [];
    for (var i = 0; i < 3; i++) {
      var sel = s[i];
      if (!sel.value || sel.selectedIndex < 0) return '';
      parts.push(sel.options[sel.selectedIndex].text.trim());
    }
    return parts[0] + ' ' + titleCase(parts[1]) + ' ' + titleCase(parts[2]);
  }

  /* Bring the vehicle search into view, highlight it, and focus the next field to fill */
  function openVehicleSearch(e) {
    if (e) e.preventDefault();
    /* The vehicle search only lives on the homepage on desktop — go there and open it */
    if (window.innerWidth >= 750 && !document.body.classList.contains('index')) {
      window.location.href = '/#find-vehicle';
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(function () {
      var box = document.querySelector('.easysearch-block-container');
      if (box) {
        box.classList.remove('cdx-pulse');
        void box.offsetWidth;
        box.classList.add('cdx-pulse');
        setTimeout(function () { box.classList.remove('cdx-pulse'); }, 1800);
      }
      var s = selects();
      var next = s.filter(function (x) { return !x.value && !x.disabled; })[0] || s[0];
      if (next) { try { next.focus({ preventScroll: true }); } catch (err) { next.focus(); } }
    }, 450);
  }

  function build() {
    var header = document.querySelector('.site-header');
    var inner = header && header.querySelector('.inner');
    if (!inner || inner.querySelector('.cdx-hdr-center')) return;

    /* Center of the header: vehicle chip */
    var center = document.createElement('div');
    center.className = 'cdx-hdr cdx-hdr-center';
    center.innerHTML =
      '<a href="#" class="cdx-truck" data-cdx-open>' +
        '<span class="cdx-truck-icon">' + ICON_TRUCK + '</span>' +
        '<span class="cdx-truck-text">' +
          '<span class="cdx-truck-kicker"></span>' +
          '<span class="cdx-truck-name"></span>' +
        '</span>' +
        '<span class="cdx-truck-edit" aria-hidden="true"></span>' +
      '</a>' +
      '<div class="cdx-app" hidden>' +
        '<button type="button" class="cdx-app-btn" aria-haspopup="listbox" aria-expanded="false">' +
          '<span class="cdx-app-kicker">Bulb Location</span>' +
          '<span class="cdx-app-current"></span>' + ICON_CHEVRON +
        '</button>' +
        '<ul class="cdx-app-menu" role="listbox" hidden></ul>' +
      '</div>';
    inner.appendChild(center);

    /* Top bar: Plug & Play (left) and ship-today countdown (right) */
    var ann = header.querySelector('.announcements');
    if (ann && !ann.querySelector('.cdx-topbar')) {
      var bar = document.createElement('div');
      bar.className = 'cdx-hdr cdx-topbar';
      /* The shop's own announcement text ("Free shipping on everything") moves into the
         middle slot so all three messages share one style and even spacing */
      var annBar = ann.querySelector('.announcement-bar');
      var annText = annBar ? annBar.textContent.replace(/\s+/g, ' ').trim() : '';
      annText = annText.replace(/free shipping on everything/i, 'Free shipping on all orders'); // desktop wording
      if (annBar && annText) annBar.classList.add('cdx-ann-hidden');
      bar.innerHTML =
        '<span class="cdx-topbar-item cdx-tb-plug">' + ICON_PLUG + '<span>Plug &amp; Play &mdash; installs in minutes</span></span>' +
        (annText ? '<span class="cdx-topbar-item cdx-tb-ann">' + ICON_SHIP + '<span></span></span>' : '<span></span>') +
        '<span class="cdx-topbar-item cdx-hdrship">' + ICON_CLOCK + '<span class="cdx-hdrship-text"></span></span>';
      if (annText) bar.querySelector('.cdx-tb-ann span').textContent = annText;
      ann.appendChild(bar);
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-cdx-open]'), function (a) {
      a.addEventListener('click', openVehicleSearch);
    });

    /* "Bulb Location" dropdown */
    var appBtn = center.querySelector('.cdx-app-btn');
    var appMenu = center.querySelector('.cdx-app-menu');
    appBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (appMenu.hidden) openAppMenu(); else closeAppMenu();
    });
    appMenu.addEventListener('click', function (e) {
      var li = e.target.closest('[data-value]');
      if (!li) return;
      var val = li.getAttribute('data-value');
      closeAppMenu();
      liveTrusted = true;
      var tries = 0;
      (function pick() {
        var bulb = bulbSelect();
        var ready = bulb && Array.prototype.some.call(bulb.options, function (o) { return o.value === val; });
        if (!ready) { if (++tries < 30) setTimeout(pick, 200); return; }
        bulb.value = val;
        bulb.dispatchEvent(new Event('change', { bubbles: true })); // the vehicle app takes the shopper to the matching bulbs
      })();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.cdx-app')) closeAppMenu();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAppMenu(); });
  }

  function bulbSelect() {
    return document.querySelector('.easysearch-block-container .easysearch-select-holder-last select');
  }

  function bulbOptions() {
    var b = bulbSelect();
    if (!b || b.disabled) return [];
    return Array.prototype.filter.call(b.options, function (o) { return o.value; });
  }

  function openAppMenu() {
    var menu = document.querySelector('.cdx-app-menu');
    var btn = document.querySelector('.cdx-app-btn');
    if (!menu) return;
    var b = bulbSelect(), current = b ? b.value : '';
    var list = bulbOptions().map(function (o) { return [o.value, o.text.trim()]; });
    var cache = readCache();
    if (!list.length && cache && cache.opts) {
      list = cache.opts;
      current = (cache.opts.filter(function (o) { return o[1] === cache.cur; })[0] || [])[0] || current;
    }
    menu.innerHTML = list.map(function (o) {
      var sel = o[0] === current;
      return '<li role="option" tabindex="0" data-value="' + String(o[0]).replace(/"/g, '&quot;') + '"' +
        (sel ? ' aria-selected="true" class="is-current"' : '') + '>' +
        '<span>' + String(o[1]).replace(/[<>&]/g, '') + '</span>' + (sel ? ICON_CHECK : '') + '</li>';
    }).join('');
    menu.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-open');
  }

  function closeAppMenu() {
    var menu = document.querySelector('.cdx-app-menu');
    var btn = document.querySelector('.cdx-app-btn');
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    btn.classList.remove('is-open');
  }

  /* Remember the last vehicle + bulb location so the header shows them instantly on the
     next page, instead of blinking empty while the vehicle app reloads its dropdowns. */
  var CACHE_KEY = 'cdxHeaderVehicle';
  var loadedAt = Date.now();
  var liveTrusted = false; // becomes true once the shopper changes/resets the search on this page
  function readCache() { try { return JSON.parse(localStorage.getItem(CACHE_KEY)) || null; } catch (e) { return null; } }
  function writeCache(o) { try { if (o) localStorage.setItem(CACHE_KEY, JSON.stringify(o)); else localStorage.removeItem(CACHE_KEY); } catch (e) {} }
  function loading() { return !liveTrusted && Date.now() - loadedAt < 8000; }

  function render(state) {
    var chip = document.querySelector('.cdx-truck');
    if (!chip) return;
    var v = state.v || '';
    chip.querySelector('.cdx-truck-kicker').textContent = v ? 'Shopping for' : 'Guaranteed fit';
    chip.querySelector('.cdx-truck-name').textContent = v || 'Add your vehicle';
    chip.querySelector('.cdx-truck-edit').innerHTML = v ? ICON_EDIT : ICON_PLUS;
    chip.classList.toggle('has-vehicle', !!v);
    chip.setAttribute('aria-label', v ? 'Shopping for ' + v + '. Change vehicle' : 'Add your vehicle');
    chip.title = v ? 'Change vehicle' : 'Add your vehicle';
    var app = document.querySelector('.cdx-app');
    if (app) {
      app.hidden = !(v && state.opts && state.opts.length > 1);
      app.querySelector('.cdx-app-current').textContent = state.cur || 'Choose one';
      app.querySelector('.cdx-app-btn').setAttribute('aria-label', 'Bulb location: ' + (state.cur || 'none selected') + '. Choose a different bulb location');
    }
  }

  function updateTruck() {
    var v = vehicleText(); // shown with textContent, so characters like & stay as-is
    var b = bulbSelect();
    var cur = b && b.value && b.selectedIndex > -1 ? b.options[b.selectedIndex].text.trim() : '';
    var opts = bulbOptions().map(function (o) { return [o.value, o.text.trim()]; });
    var cache = readCache();

    if (loading() && cache && cache.v) {
      /* The vehicle app is still filling its dropdowns — keep showing what we remembered */
      if (!v) { render(cache); return; }
      if (v === cache.v && !opts.length) { render({ v: v, cur: cur || cache.cur, opts: cache.opts }); return; }
    }
    var state = { v: v, cur: cur, opts: opts };
    writeCache(v ? state : null);
    render(state);
  }

  /* Ship-today countdown, 2:00 PM Eastern cutoff, Monday–Friday */
  function updateShip() {
    var el = document.querySelector('.cdx-hdrship-text');
    if (!el) return;
    var p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var day = p.weekday;                      // Mon, Tue, ...
    var mins = (parseInt(p.hour, 10) % 24) * 60 + parseInt(p.minute, 10);
    var cutoff = 14 * 60;
    var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(day) > -1;
    if (weekday && mins < cutoff) {
      var left = cutoff - mins, h = Math.floor(left / 60), m = left % 60;
      var t = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
      el.innerHTML = 'Order within <strong>' + t + '</strong> &mdash; ships today';
    } else {
      var nextDay = (day === 'Fri' || day === 'Sat' || day === 'Sun') ? 'Monday' : 'tomorrow';
      el.innerHTML = 'Order now &mdash; ships <strong>' + nextDay + '</strong>';
    }
  }

  function init() {
    build();
    var c = readCache();
    if (c && c.v) render(c); // show the remembered vehicle right away
    updateTruck();
    updateShip();
    setInterval(updateShip, 30000);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.easysearch-block-container')) {
        if (e.isTrusted) liveTrusted = true;
        setTimeout(updateTruck, 50);
        setTimeout(updateTruck, 800);
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.easysearch-btn-reset')) {
        liveTrusted = true;
        writeCache(null);
        setTimeout(updateTruck, 300);
      }
    });
    /* The vehicle app fills its dropdowns after load — keep checking for a few seconds */
    var tries = 0;
    var t = setInterval(function () { updateTruck(); if (++tries > 20) clearInterval(t); }, 500);

    /* Arrived from another page's "Shopping for" button: highlight the vehicle search */
    if (location.hash === '#find-vehicle' && document.body.classList.contains('index')) {
      setTimeout(function () {
        openVehicleSearch();
        try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {}
      }, 900);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* =====================================================================
   9/23/26 — VEHICLE SEARCH → "EVERYTHING FOR YOUR VEHICLE" PAGE (desktop + phones)
   The Bulb Location field is hidden (custom.css). As soon as the shopper has
   Year / Make / Model / Trim (or the vehicle has no trims), save the vehicle the
   same way the search app does and open /collections/all?view=my-vehicle.
   ===================================================================== */
(function () {
  if (window.__cdxVehicleGo) return;
  window.__cdxVehicleGo = true;
  var D = 'easysearch-preselect-delimiter';
  var PAGE = '/collections/all?view=my-vehicle';

  function fields() {
    return Array.prototype.slice.call(document.querySelectorAll('.easysearch-block-container .easysearch-holder select'));
  }
  function realOptions(sel) {
    return sel ? Array.prototype.filter.call(sel.options, function (o) { return o.value; }) : [];
  }

  function go(year, make, model, trim) {
    try {
      /* The app restores its fields from "easysearch-preselect"; our fit lookup reads "-fitment" */
      var saved = JSON.stringify({ value: [year, make, model, trim || '', ''].join(D) + D, expires: String(Date.now() + 30 * 86400000) });
      localStorage.setItem('easysearch-preselect', saved);
      localStorage.setItem('easysearch-preselect-fitment', saved);
      localStorage.removeItem('cdxHeaderVehicle');
    } catch (e) {}
    location.href = PAGE + '&vehicle=' + encodeURIComponent([year, make, model, trim || ''].join('|'));
  }

  var waiting = 0;
  function afterModel() {
    /* Wait for the app to load the trims, then decide: pick one, only one, or none */
    var id = ++waiting, tries = 0;
    function check() {
      if (id !== waiting) return;
      var f = fields();
      if (f.length < 4 || !f[0].value || !f[1].value || !f[2].value) return;
      var trim = f[3], bulb = f[4];
      var trims = realOptions(trim);
      if (!trim.disabled && trims.length === 1) { go(f[0].value, f[1].value, f[2].value, trims[0].value); return; }
      if (!trim.disabled && trims.length > 1) return; // shopper picks a trim
      if (trim.disabled && realOptions(bulb).length) { go(f[0].value, f[1].value, f[2].value, ''); return; }
      if (++tries < 25) setTimeout(check, 200);
    }
    setTimeout(check, 350);
  }

  /* Desktop "Shop now" button between Trim and Reset: opens the page for the vehicle
     already in the fields, or points the shopper at the next field to fill in */
  var ICON_ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  function shopNow() {
    var f = fields();
    if (f.length < 4) return;
    var need = null;
    for (var i = 0; i < 3; i++) { if (!f[i].value) { need = f[i]; break; } }
    var trims = realOptions(f[3]);
    if (!need && !f[3].disabled && trims.length > 1 && !f[3].value) need = f[3];
    if (need) {
      need.classList.remove('cdx-need'); void need.offsetWidth; need.classList.add('cdx-need');
      setTimeout(function () { need.classList.remove('cdx-need'); }, 1600);
      try { need.focus(); if (need.showPicker) need.showPicker(); } catch (err) {}
      return;
    }
    go(f[0].value, f[1].value, f[2].value, f[3].value || (trims.length === 1 ? trims[0].value : ''));
  }
  function addShopNow() {
    var holder = document.querySelector('.easysearch-block-container .easysearch-holder');
    if (!holder || holder.querySelector('.cdx-shop-now')) return !!holder;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cdx-shop-now';
    btn.innerHTML = '<span>Shop now</span>' + ICON_ARROW;
    btn.setAttribute('aria-label', 'Shop everything for this vehicle');
    btn.addEventListener('click', shopNow);
    holder.insertBefore(btn, holder.querySelector('.easysearch-btn-reset'));
    return true;
  }
  var tries = 0;
  (function place() { if (!addShopNow() && ++tries < 20) setTimeout(place, 300); })();

  document.addEventListener('change', function (e) {
    if (!e.isTrusted && !window.__cdxVehicleGoTest) return; // ignore the app restoring a saved search
    var f = fields();
    var i = f.indexOf(e.target);
    if (i === 2 && e.target.value) { afterModel(); return; }
    if (i === 3 && e.target.value && f[0].value && f[1].value && f[2].value) {
      waiting++;
      go(f[0].value, f[1].value, f[2].value, e.target.value);
    }
  }, true);
})();


/* =====================================================================
   9/23/26 — PHONES: "SHOPPING FOR <vehicle>" BAR
   On phones the vehicle search starts closed: only the "Shopping for" bar shows
   (or "Select your vehicle" when none is saved). The pencil / plus opens the
   Year / Make / Model / Trim fields underneath, restyled to match (custom.css,
   .cdx-mchip). The "Reset" button (circular arrow + word) shows in the bar while the search is open.
   On the homepage, with no vehicle picked yet, the fields start open.
   ===================================================================== */
(function () {
  if (window.__cdxMobileChip) return;
  window.__cdxMobileChip = true;
  var D = 'easysearch-preselect-delimiter';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17H3v-5l2-5h9l3 5h3a1 1 0 0 1 1 1v4h-2"/><path d="M9 17h6"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M5 12h12"/></svg>';
  var ICON_EDIT = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_RESET = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 2.64-6.36"/><path d="M3 4v5h5"/></svg>';

  function titleCase(s) {
    return String(s).split(/(\s+|-|\/)/).map(function (w) {
      if (!/[A-Za-z]/.test(w)) return w;
      if (/^(GMC|RAM|BMW|VW|SRT|HD|SUV|II|III)$/i.test(w) || w.length <= 2) return w.toUpperCase();
      if (/[a-z]/.test(w)) return w;
      return w.charAt(0) + w.slice(1).toLowerCase();
    }).join('');
  }
  function saved() {
    var raw = null;
    try { raw = localStorage.getItem('easysearch-preselect-fitment') || localStorage.getItem('easysearch-preselect'); } catch (e) {}
    if (!raw) return null;
    var val = raw;
    try { var j = JSON.parse(raw); if (j && typeof j.value === 'string') val = j.value; } catch (e) {}
    var p = String(val).split(D);
    if (!/^\d{4}$/.test(p[0] || '') || !p[1] || !p[2]) return null;
    return { year: p[0], make: p[1], model: p[2], trim: p[3] || '' };
  }

  var box = null, chip = null, current = null, autoOpened = false;
  function setOpen(open, noFocus) {
    box.classList.toggle('cdx-editing', open);
    var ed = chip.querySelector('.cdx-mchip-edit');
    ed.innerHTML = open ? ICON_CLOSE : (current ? ICON_EDIT : ICON_PLUS);
    ed.setAttribute('aria-label', open ? 'Close vehicle search' : (current ? 'Change vehicle' : 'Select your vehicle'));
    ed.setAttribute('aria-expanded', String(open));
    if (open && !noFocus) {
      var f = Array.prototype.filter.call(box.querySelectorAll('.easysearch-holder select'), function (x) { return !x.value && !x.disabled; })[0];
      if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (err) {} }, 50);
    }
  }
  function build() {
    box = document.querySelector('.easysearch-block-container');
    if (!box) return false;
    chip = box.querySelector('.cdx-mchip');
    if (chip) return true;
    chip = document.createElement('div');
    chip.className = 'cdx-mchip';
    chip.innerHTML = '<div class="cdx-mchip-pill">' +
      '<a class="cdx-mchip-main" href="/collections/all?view=my-vehicle">' +
        '<span class="cdx-mchip-icon">' + ICON_TRUCK + '</span>' +
        '<span class="cdx-mchip-text"><span class="cdx-mchip-kicker"></span><span class="cdx-mchip-name"></span></span>' +
      '</a>' +
      '<a class="cdx-mchip-shop" href="/collections/all?view=my-vehicle">All Bulbs</a>' +
      '<button type="button" class="cdx-mchip-reset" aria-label="Reset vehicle search">' + ICON_RESET + '<span>Reset</span></button>' +
      '<button type="button" class="cdx-mchip-edit" aria-expanded="false"></button></div>';
    box.insertBefore(chip, box.firstChild);
    /* "All Bulbs" button: back to everything that fits the saved vehicle */
    if (!document.getElementById('cdx-mchip-shop-css')) {
      var st = document.createElement('style');
      st.id = 'cdx-mchip-shop-css';
      st.textContent = '.cdx-mchip-shop{display:none}' +
        '@media only screen and (max-width:749px){' +
        '.easysearch-block-container.cdx-has-vehicle:not(.cdx-editing) .cdx-mchip-shop{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;height:40px;padding:0 12px;border-radius:8px;background:hsl(var(--blue-dark1));color:#fff;font-size:12px;font-weight:700;letter-spacing:.03em;text-transform:uppercase;text-decoration:none;white-space:nowrap}' +
        '.easysearch-block-container.cdx-has-vehicle:not(.cdx-editing) .cdx-mchip-pill{height:auto;min-height:56px;padding-top:6px;padding-bottom:6px}' +
        '.easysearch-block-container.cdx-has-vehicle .cdx-mchip-name{font-size:16px;white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
        '.cdx-ymm-sticky{position:-webkit-sticky;position:sticky;top:calc(var(--header-height) - 1px);z-index:5}' +
        '.cdx-ymm-sticky .easysearch-block-container{position:relative!important;top:auto!important;transform:none!important;transition:none!important}' +
        '.easysearch-block-container.cdx-editing.cdx-has-vehicle .cdx-mchip-reset{flex:0 0 auto;width:auto;height:40px;gap:6px;padding:0 12px;border:1px solid rgba(255,255,255,.3);background:rgba(255,255,255,.1);color:#fff;font-size:12px;font-weight:700;letter-spacing:.04em;text-transform:uppercase}' +
        '}';
      document.head.appendChild(st);
    }
    chip.querySelector('.cdx-mchip-edit').addEventListener('click', function () {
      setOpen(!box.classList.contains('cdx-editing'));
    });
    chip.querySelector('.cdx-mchip-main').addEventListener('click', function (e) {
      if (!current) { e.preventDefault(); setOpen(true); } // no vehicle yet: open the search
    });
    chip.querySelector('.cdx-mchip-reset').addEventListener('click', function () {
      var r = box.querySelector('.easysearch-btn-reset');
      if (r) r.click();
    });
    return true;
  }
  function update() {
    if (!box && !build()) return;
    var v = saved();
    current = v;
    box.classList.toggle('cdx-has-vehicle', !!v);
    var name = v ? v.year + ' ' + titleCase(v.make) + ' ' + titleCase(v.model) : '';
    chip.querySelector('.cdx-mchip-kicker').textContent = v ? 'Shopping for' : 'Guaranteed fit';
    chip.querySelector('.cdx-mchip-name').textContent = v ? name : 'Select your vehicle';
    var main = chip.querySelector('.cdx-mchip-main');
    main.href = v ? '/collections/all?view=my-vehicle&vehicle=' + encodeURIComponent([v.year, v.make, v.model, v.trim].join('|')) : '#';
    var shop = chip.querySelector('.cdx-mchip-shop');
    if (shop) {
      shop.href = main.href;
      shop.setAttribute('aria-label', v ? 'All bulbs that fit your ' + name : 'All bulbs');
    }
    main.setAttribute('aria-label', v ? 'Shopping for ' + name + '. See everything that fits' : 'Select your vehicle');
    /* Homepage with no vehicle picked yet: start with the Year / Make / Model / Trim fields open
       (once per page load, so closing it with the X sticks) */
    if (!autoOpened) {
      autoOpened = true;
      if (!v && document.body.classList.contains('index')) { setOpen(true, true); return; }
    }
    setOpen(box.classList.contains('cdx-editing'), true);
  }

  /* Reset clears the saved vehicle; the search stays open so a new one can be picked */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.easysearch-btn-reset')) {
      try { localStorage.removeItem('easysearch-preselect-fitment'); localStorage.removeItem('easysearch-preselect'); } catch (err) {}
      setTimeout(update, 50);
    }
  }, true);

  var n = 0;
  (function tick() { update(); if (++n < 12) setTimeout(tick, n < 4 ? 250 : 1000); })();
})();
